<template>
   <div  class="filter__panel">
        <div class="filter__panel--item">
            <div class="filter__panel--title">
                How long ?
            </div>
            <div class="filter__panel--length">
                Minimal length :
                <div class="filter__panel--length-days">
                    <button class="filter__panel--length-btn"  @click="updateFilter('minDuration', 'add', '-1')">
                        <Svg className="filter__panel--length-svg" icon="minus"/>
                    </button>
                    <input type="text" id="filter-min-days" class="filter__panel--length-input" placeholder="1" v-model="filter.minDuration">
                    <button class="filter__panel--length-btn" @click="updateFilter('minDuration', 'add', '1')">
                        <Svg className="filter__panel--length-svg" icon="more"/>
                    </button>
                </div>
                days
            </div>
            <div class="filter__panel--length">
                Maximal length :
                <div class="filter__panel--length-days">
                    <button class="filter__panel--length-btn" @click="updateFilter('maxDuration', 'add', '-1')">
                        <Svg className="filter__panel--length-svg" icon="minus"/>
                    </button>
                    <input type="text" id="filter-max-days" class="filter__panel--length-input" placeholder="" v-model="filter.maxDuration">
                    <button class="filter__panel--length-btn" @click="updateFilter('maxDuration', 'add', '1')">
                        <Svg className="filter__panel--length-svg" icon="more"/>
                    </button>
                </div>
                days
            </div>
        </div>
        <div class="filter__panel--item">
            <div class="filter__panel--title">
                When ?
            </div>
            <ul class="filter__panel--when">
                <li v-for="month in months" :key="month" class="filter__panel--when-item" :class="{'filter__panel--when-selected': filter.when.filter(el=> el === month).length > 0}" @click="updateFilter('when', 'push', month)">{{month}}</li>
            </ul>
        </div>
        <div class="filter__panel--item">
            <div class="filter__panel--title">
                Where ?
            </div>
            <div class="filter__panel--where">
                <ul class="filter__panel--where-line">
                    <li 
                        v-for="continent in data.stats.continents.sort((a,b) => a.name.localeCompare(b.name))" 
                        :key="continent" 
                        class="filter__panel--where-item filter__panel--where-continent" 
                        :class="{'filter__panel--where-selected' : filter.continent.filter(el=> el === continent.iso).length > 0}" 
                        @click="updateFilter('continent', 'push', continent.iso)"
                    >
                        {{continent.name}}
                    </li>
                </ul>
                <ul class="filter__panel--where-line">
                    <li 
                        v-for="country in data.stats.countries.sort((a,b) => a.name.localeCompare(b.name))" 
                        :key="country" 
                        class="filter__panel--where-item filter__panel--where-country" 
                        :class="{'filter__panel--where-selected' : filter.country.filter(el=> el === country.iso).length > 0}" 
                        @click="updateFilter('country', 'push', country.iso)"
                    >
                        {{country.name}}
                    </li>
                </ul>
            </div>
        </div>
        <div class="filter__panel--item filter__panel--line">
            <div class="filter__panel--action">
                <button class="filter__panel--button btn btn__spacing btn--white" @click="resetFilter">
                    reset filters
                </button>
                <button class="filter__panel--button btn btn__spacing btn--blue" @click="saveFilter">
                    Search trails
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import {ref, watch} from 'vue';
import Svg from '../utils/Svg';


import moment from 'moment';

export default {
    props:['data', 'filters'],
    components: {
        Svg
    },
    setup(props, {emit}){
        const months = moment.monthsShort();

        const minDuration = ref(props.filters.minDuration);
        const maxDuration = ref(props.filters.maxDuration)

        const filter = ref(props.filters);
        console.log(filter.value);

        watch(props, (newVal, oldVal) => {
            // console.log('in filter change', filter.value);
            // filter.value = newVal.filters;
        })

        const watchFilters = watch(props.filters, (newVal, oldVal) => {
            minDuration.value = props.filters.minDuration;
            maxDuration.value = props.filters.maxDuration;
        })

        const watchMinDuration = watch([minDuration, maxDuration], ([newMin, newMax], [oldMin, oldMax]) => {
            if(newMin !== '' && newMax !== ''){
                const pattern = /^\d+$/; //check if is number
                if(pattern.test(newMin) && pattern.test(newMax)){
                    filter.value['minDuration'] = newMin *1;
                    filter.value['maxDuration'] = newMax *1;
                }else{
                     filter.value['minDuration'] = oldMin *1;
                     filter.value['maxDuration'] = oldMax *1;
                }
            }
        })

        const updateFilter = (field, action, value) => {
            let newVal;
            if(action === 'add') newVal = filter.value[field]*1 + value*1;

            if(action === 'push'){
                if(filter.value[field].includes(value)){
                    filter.value[field] = filter.value[field].filter(el=> el !== value);
                }else{
                    filter.value[field].push(value);
                }
            }
            //Validators
            if(newVal > 0) filter.value[field] = newVal;

            emit('updateFilter', filter.value);
        }

        const resetFilter = () => {
            filter.value.minDuration = 1;
            filter.value.maxDuration = props.data.stats.maxDuration;
            filter.value.when = [];
            filter.value.country = [];
            filter.value.continent = [];
            emit('updateSearch', filter.value);
        }
        const saveFilter = () => {
            console.log(filter.value.maxDuration);
            emit('updateSearch', filter.value);
        }

        return {
            filter, 
            maxDuration,
            minDuration,
            months,
            resetFilter,
            saveFilter,
            updateFilter
        };
    },
    emits:['updateSearch', 'updateFilter']
}
</script>

<style lang="scss">

</style>